<div fdCompact>
<router-outlet></router-outlet>
</div>